import { Container } from '../common/container.models';
import { AggregationType } from '../common/health.models';
import { Sensor } from '../common/sensors.models';

export class Measurements {
  tid?: string;
  sensorBk?: string;
  timestamps?: string[];
  values: number[];
  sampling?: string;
}

export class DESensor extends Sensor {
  label?: string;
  longLabel?: string;
  containerPath?: string;

  measurements?: Measurements;

  // for filtering purposes
  show?: boolean;
  isChecked?: boolean;
}

export class DEContainer extends Container {
  selectedSensors?: DESensor[];
  containerPath?: string;
  siblingsContainers?: DEContainer[];
}

export class PaginationMetadata<T> {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  total_pages: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  page_size: number;
  page: number;
  prev: string | null;
  next: string | null;
  items: T[];
}
export class PaginationWrapper<T> {
  data: PaginationMetadata<T>;
}

export class PaginatedSensor {
  data: DESensor[];
}

export class PaginatedComponent {
  data: DEContainer[];
}

export interface AxisSettings {
  key: string | null;
  name: string | null;
  unit: string | null;
  scalingFactor?: number;
  chartType: string;
  lineStyle: string;
  displayDataPoints: boolean;
  aggregationType: AggregationType;
  zeroYAxis: boolean;
  open: boolean;
}

export interface GlobalSettings {
  chartMode: string;
  groupBy: string;
  dataType: string;
}

export const chartModes: { label: string; value: string; code: string }[] = [
  { label: 'Stacked charts', value: 'stacked', code: 'st' },
  { label: 'Single chart', value: 'single', code: 'si' },
];

export const dataTypes: { label: string; value: string; code: string }[] = [
  { label: 'Cleansed data', value: 'cleansed', code: 'c' },
  { label: 'All data', value: 'all', code: 'a' },
];

export const groupTypes: { label: string; value: string; code: string }[] = [
  { label: 'Sensor', value: 'sensor', code: 's' },
  { label: 'Unit', value: 'unit', code: 'u' },
];

export const chartTypes: { label: string; value: string; code: string }[] = [
  { label: 'Line chart', value: 'line', code: 'l' },
  { label: 'Bar chart', value: 'bar', code: 'b' },
  { label: 'Scatterplot', value: 'scatter', code: 's' },
  // { label: 'Boxplot', value: 'box', code: 'x' },
];
export const lineStyles: { label: string; value: string; code: string }[] = [
  { label: 'Linear', value: 'linear', code: 'l' },
  { label: 'Step', value: 'step', code: 's' },
];
export const aggregationTypes: { label: string; value: AggregationType; code: string }[] = [
  { label: 'Average', value: AggregationType.AVG, code: 'av' },
  { label: 'Minimum', value: AggregationType.MIN, code: 'mi' },
  { label: 'Maximum', value: AggregationType.MAX, code: 'ma' },
  { label: 'First value', value: AggregationType.FIRST, code: 'fi' },
  { label: 'Last value', value: AggregationType.LAST, code: 'la' },
];
